module.exports = __webpack_public_path__ + "img/hr-sand-decal-01.0fc40957.png";